import {
  CreateInterfaceDeploymentRequestRequest,
  CreateInterfaceDeploymentRequestResponse,
  DeploymentRequestRestResource,
  UpdateInterfaceDeploymentRequestRequest,
  UpdateInterfaceDeploymentRequestResponse,
  GetDeploymentRequestRequest,
  GetDeploymentRequestResponse,
  UpdateInterfaceDeploymentRequestStatusRequest,
  UpdateInterfaceDeploymentRequestStatusResponse,
  CreateDeploymentRequestComponentNameRequest,
  CreateDeploymentRequestComponentNameResponse,
  CreateDeploymentRequestDataKindNamesRequest,
  CreateDeploymentRequestDataKindNamesResponse,
  CreateDeploymentRequestInterfacePartnerNamesRequest,
  CreateDeploymentRequestInterfacePartnerNamesResponse,
} from ".";
import { useRestResourceHook } from "../use-rest-resource-hook";

export const useCreateDeploymentRequestDataKindNames = () =>
  useRestResourceHook<
    CreateDeploymentRequestDataKindNamesRequest,
    CreateDeploymentRequestDataKindNamesResponse
  >((request) =>
    DeploymentRequestRestResource.createDeploymentRequestDataKindNames(request),
  );

export const useCreateInterfaceDeploymentRequest = () =>
  useRestResourceHook<
    CreateInterfaceDeploymentRequestRequest,
    CreateInterfaceDeploymentRequestResponse
  >((request) =>
    DeploymentRequestRestResource.createInterfaceDeploymentRequest(request),
  );

export const useUpdateInterfaceDeploymentRequest = () =>
  useRestResourceHook<
    UpdateInterfaceDeploymentRequestRequest,
    UpdateInterfaceDeploymentRequestResponse
  >((request) =>
    DeploymentRequestRestResource.updateInterfaceDeploymentRequest(request),
  );

export const useGetDeploymentRequest = () =>
  useRestResourceHook<
    GetDeploymentRequestRequest,
    GetDeploymentRequestResponse
  >((request) => DeploymentRequestRestResource.getDeploymentRequest(request));

export const useCreateDeployPartnerNames = () =>
  useRestResourceHook<
    CreateDeploymentRequestInterfacePartnerNamesRequest,
    CreateDeploymentRequestInterfacePartnerNamesResponse
  >((request) =>
    DeploymentRequestRestResource.createDeployPartnerNames(request),
  );

export const useUpdateInterfaceDeploymentRequestStatus = () =>
  useRestResourceHook<
    UpdateInterfaceDeploymentRequestStatusRequest,
    UpdateInterfaceDeploymentRequestStatusResponse
  >((request) =>
    DeploymentRequestRestResource.updateInterfaceDeploymentRequestStatus(
      request,
    ),
  );

export const useCreateDeploymentRequestComponentName = () =>
  useRestResourceHook<
    CreateDeploymentRequestComponentNameRequest,
    CreateDeploymentRequestComponentNameResponse
  >((request) =>
    DeploymentRequestRestResource.createDeploymentRequestComponentName(request),
  );
